import styled from "styled-components";
import Input from "components/Input";
import { colors } from '../styles/colors';

export const SearchInput = styled(Input).attrs(() => ({
  placeholder: "Digite o código da cotação",
  name: "BuscaOrigemRazaoSocialStatus",
  className: "bg-white w-100 quotesSearch"
}))``;

export const Container = styled.div`
  display: flex;
  align-items: center;
  gap: 40px;
  margin-top: 32px;
`;

export const ContentSection = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
`;

export const IconWrapper = styled.div`
  display: flex;
  align-items: center;
`;

export const TextContent = styled.div`
  width: 439px;
  height: 57px;
  display: flex;
  align-items: center;
`;

export const InstructionText = styled.div`
  font-family: 'Lato';
  font-weight: 400;
  font-size: 15px;
  line-height: 1.1;
  letter-spacing: 0%;
  color: ${colors.viveoBlueText};
`;

export const StrongText = styled.strong`
  font-weight: 700;
`;

export const ActionSection = styled.div`
  background-color: ${colors.greenDarkViveo};
  border-radius: 12px;
  padding: 24px;
  height: 90px;
  display: flex;
  align-items: center;
  gap: 24px;
  width: 775px;
  box-sizing: border-box;
`;

export const StyledDropdownContainer = styled.div`
  width: 159px;
  height: 43px;

  > div {
    height: 43px !important;
    width: 159px !important;
    border: 2px solid ${colors.viveoBlueText} !important;
    border-radius: 5px !important;
    font-size: 13px !important;
    position: relative !important;
  }

  .dropdwn-img {
    top: 50% !important;
    transform: translateY(-50%) !important;
  }

  div[opened] {
    border-radius: 5px 5px 0 0 !important;
    
    .dropdwn-img {
      transform: translateY(-50%) rotate(180deg) !important;
    }
  }

  .selected {
    color: ${colors.viveoBlueText} !important;
    font-weight: 400 !important;
  }

  .options {
    position: absolute !important;
    top: 41px !important;
    left: -2px !important;
    width: 159px !important;
    border: 2px solid ${colors.viveoBlueText} !important;
    border-top: none !important;
    border-radius: 0 0 5px 5px !important;
    background-color: white !important;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1) !important;
    z-index: 1000 !important;
    min-height: auto !important;
  }

  .option {
    display: flex !important;
    align-items: center !important;
    padding: 10px 16px !important;
    min-height: 36px !important;
    font-size: 13px !important;
    font-weight: 400 !important;
    color: ${colors.viveoBlueText} !important;
    cursor: pointer !important;
    border-bottom: 1px solid #f0f0f0 !important;
    transition: all 0.2s ease !important;
    
    &:last-child {
      border-bottom: none !important;
      border-radius: 0 0 3px 3px !important;
    }

    &:hover {
      background-color: ${colors.greenDarkViveo} !important;
      color: ${colors.white} !important;
    }
  }
`;

export const SearchContainer = styled.div`
  position: relative;
  width: 352px;
`;

export const SearchInputStyled = styled(SearchInput)`
  width: 100%;
  height: 43px;
  padding-right: 40px;
`;

export const ActionButton = styled.button<{ disabled: boolean }>`
  background-color: ${({ disabled }) => disabled ? colors.vpcGray : colors.cyanLightViveo};
  width: 155px;
  height: 43px;
  padding: 12px 20px;
  cursor: ${({ disabled }) => disabled ? 'not-allowed' : 'pointer'};
  border: none;
  border-radius: 4px;
  font-family: 'Lato';
  font-size: 14px;
  font-weight: 500;
  
  &:hover {
    opacity: ${({ disabled }) => disabled ? 1 : 0.9};
  }
`;